import Icon from './Icons'
import '../styles/Toast.css'

const ICONS = { success: 'check', error: 'warning', info: 'info' }

const ToastStack = ({ toasts, onDismiss }) => {
  if (!toasts.length) return null
  return (
    <div className="toast-stack" role="status" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast-${t.type}`}>
          <Icon name={ICONS[t.type] || 'info'} size={16} />
          <span className="toast-message">{t.message}</span>
          <button className="toast-close" onClick={() => onDismiss(t.id)} aria-label="Fermer">
            <Icon name="close" size={13} />
          </button>
        </div>
      ))}
    </div>
  )
}

export default ToastStack
